import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';
import type { Company as CompanyModel } from 'tio-data/data/resources/company.type';
import { reportingCompany } from 'tio-employee/utils/reporting-company';

export default class AuthenticatedAdminReportingTasProgramsRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;

  // Layout configuration - declares this route needs full-width layout
  layoutType = 'full-width' as const;

  queryParams = {
    applicationStatus: { refreshModel: false },
    applicationCreatedAtStart: { refreshModel: false },
    coursesEndDate: { refreshModel: false },
    includeCourses: { refreshModel: false },
    includePayments: { refreshModel: false },
  };

  async model() {
    const id = reportingCompany(this.sessionContext.activeRoles)?.id;
    if (!id) {
      return null;
    }

    const peeked = this.store.peekRecord<CompanyModel>('company', id);
    if (peeked) {
      return peeked;
    }

    const { content } = (await this.store.request(
      findRecord<CompanyModel>('company', id, { include: 'company-setting' })
    )) as { content: { data: CompanyModel } };
    return content.data;
  }
}
